module.exports = __webpack_public_path__ + "img/forNight.6e6ec5d0.jpg";